<template>
    <div>
      <iframe class="tdemptyclass" src="https://docs.google.com/forms/d/1xvqXoq2rSsYSYEmamhsLfmhLMK6okFs19gPfUOQTIG4/viewform?embedded=true" width="800" height="1160" frameborder="0" marginheight="0" marginwidth="0">
      {{ $t('query.loading') }}
      </iframe>
    </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  }
}

</script>

<style scoped>

</style>
